var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isConversa)?_c('StaticContent',{attrs:{"data-cy":"conversa","resource":"conversa"}}):_c('StaticContent',{attrs:{"data-cy":"sin_conversa","resource":"sin_conversa"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }